import { ContractAttachments } from "./ContractAttachments";
import { useContractDetail } from "./contractDetailContext";
import { ContractExportSection } from "./ContractExportSection";
import { ContractLinksSection } from "./ContractLinksSection";
import { ContractObligationsSection } from "./ContractObligationsSection";
import { ContractTimelineSection } from "./ContractTimelineSection";
import { ContractWorkItemsSection } from "./ContractWorkItemsSection";

/**
 * KAYIT bölümü — sözleşmenin idari yüzü.
 *
 * ### ⚠ Neden bunlar bir arada
 *
 * Buradaki altı bölümün ortak yanı, sözleşmenin METNİYLE ya da İLERLEYİŞİYLE değil
 * DOSYASIYLA ilgili olmaları: nelere bağlı, kim ne takip ediyor, hangi belgeler ekli, ne
 * taahhüt edildi, ne oldu, dışarı nasıl çıkar. Hepsi Genel Bakış'ta duruyordu ve orayı
 * dokuz kartlık bir yığına çeviriyordu — sözleşmeyi açan kullanıcının ilk sorusu
 * ("nerede duruyor, benden ne bekleniyor") künyeyle ekler ve yükümlülükler arasında
 * kayboluyordu.
 *
 * ### ⚠ Sıra bir HİYERARŞİ
 *
 * Bağlı kayıtlar (ek protokol/tadil) sözleşmenin kendi ailesi — önce o. Sonra iç çalışma
 * (notlar/görevler), sonra ekler, sonra yükümlülükler, sonra geçmiş, en sonda dışa
 * aktarma: kaydı OKUMAKTAN kaydı ÇIKARMAYA doğru.
 */
export function ContractRecordPage() {
  const { id, s, kayitYazma } = useContractDetail();

  return (
    <div className="flex flex-col gap-4">
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        {/* BAĞLI KAYITLAR (CLOS-253 `[161]`) — ek protokol, tadil, yenileme. */}
        <ContractLinksSection contractId={id} kayitYazma={kayitYazma} />

        {/*
          ⚠ İÇ ÇALIŞMA YÜZEYİ AYRI BÖLÜM (CLOS-1113 · rapor 1 BUG-09). Not/görev oluşturma
          formu paylaşım ekranının içindeydi ve o ekranın amacını bulanıklaştırıyordu:
          "karşı tarafa ne açtık?" ile "kendi ekibimiz ne çalışıyor?" iki ayrı soru.
        */}
        <ContractWorkItemsSection contractId={id} kayitYazma={kayitYazma} />

        {/*
          EKLER (CLOS-121 `[103]`) — ana belgeden ve versiyon geçmişinden AYRI bölüm.

          ⚠ Sözleşmenin kendi metni ve sürümleri Belge bölümünde; burası metnin DIŞINDA
          kalan belgeler: imza sirküleri, vekâletname, teklif, yazışma.
        */}
        <ContractAttachments contractId={s.id} kayitYazma={kayitYazma} />
      </div>

      {/* YÜKÜMLÜLÜKLER (CLOS-231 `[196]`) — kritik tarihlerden AYRI kavram: taraf/sorumlu/tekrar taşıyan iş kalemi. */}
      <ContractObligationsSection contractId={id} kayitYazma={kayitYazma} />

      {/* FAALİYET ZAMAN ÇİZELGESİ (CLOS-230 `[197]`) — CLOS-281 Aktivite projeksiyonunun bağlamsal kullanımı. */}
      <ContractTimelineSection contractId={id} />

      {/* SÖZLEŞME PAKETİNİ GÜVENLİ DIŞA AKTARMA (CLOS-234 `[198]`). */}
      <ContractExportSection contractId={id} kayitYazma={kayitYazma} />
    </div>
  );
}
